(() => {
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'ar') return;

  const translations = new Map([
    ['Bring life to your home.', 'أضف الحياة إلى منزلك.'],
    ['Plant Experts', 'خبراء النباتات']
  ]);

  /* 9 Sep 2026 — the sort-by dropdown.
     The labels inside <select name="sort_by"> are Shopify's own
     collection.sort_options / search.sort_options names. The storefront still
     serves them in English on /ar/, and they are not theme content, so no
     translationsRegister call and no locales/ar.json key can reach them. They
     are mapped here by option VALUE, which is stable, never by label. Nothing
     else is touched: the value the form submits is unchanged, so facets.js and
     the sort URL parameter behave exactly as before.
     The clean fix, if the theme is ever edited with the CLI, is one line in
     snippets/facets.liquid — print a locale key instead of {{ option.name }}. */
  const sortLabels = {
    'manual': 'المميزة',
    'best-selling': 'الأكثر مبيعًا',
    'most-relevant': 'الأكثر صلة',
    'relevance': 'الأكثر صلة',
    'title-ascending': 'أبجديًا، من أ إلى ي',
    'title-descending': 'أبجديًا، من ي إلى أ',
    'price-ascending': 'السعر: من الأقل إلى الأعلى',
    'price-descending': 'السعر: من الأعلى إلى الأقل',
    'created-ascending': 'التاريخ: من الأقدم إلى الأحدث',
    'created-descending': 'التاريخ: من الأحدث إلى الأقدم'
  };

  const applyTranslations = () => {
    document.querySelectorAll('.slideshow h3, #site-footer a').forEach((element) => {
      const source = element.textContent.trim();
      const translation = translations.get(source);
      if (translation) element.textContent = translation;
    });
  };

  /* 9 Sep 2026 — the copyright line.
     sections/footer.liquid prints "© 2026, NABAT." — all Latin and neutral
     characters, so inside the RTL paragraph the bidi algorithm re-orders the
     neutrals and it reads ".NABAT ,2026 ©". The characters were always right;
     only their visual order was wrong. Forcing LTR on that one <small> fixes
     it without touching the footer section or its wording. (assets/nabat-rtl.css
     would be the natural home, but that file is not referenced by the theme.) */
  const applyCopyrightDirection = () => {
    document.querySelectorAll('.site-footer__copyright small').forEach((element) => {
      if (element.classList.contains('site-footer__powered-by-link-container')) return;
      element.style.direction = 'ltr';
      element.style.display = 'inline-block';
    });
  };

  const applySortLabels = () => {
    document.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
      const label = sortLabels[option.value];
      if (label && option.textContent.trim() !== label) option.textContent = label;
    });
  };

  /* facets.js replaces the whole filter/sort block over AJAX whenever a filter
     changes, which throws away the labels above, so re-apply them once per
     frame after any DOM change. */
  let queued = false;
  const watchForRerenders = () => {
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        applySortLabels();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const run = () => {
    applyTranslations();
    applyCopyrightDirection();
    applySortLabels();
    watchForRerenders();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
